import { useState, useEffect } from 'react';
import pb from '../pb';

// Strip PocketBase system fields before writing.
function clean(data) {
  const { id, created, updated, collectionId, collectionName, expand, ...rest } = data || {};
  return rest;
}

// Live-synced list for a PocketBase collection.
// Returns the items plus create/update/remove helpers.
export function usePbCollection(name, { sort = 'created' } = {}) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    let unsub = null;
    const col = pb.collection(name);

    const load = () =>
      col.getFullList({ sort })
        .then((list) => { if (active) { setItems(list); setLoading(false); } })
        .catch(() => { if (active) setLoading(false); });

    load();
    col.subscribe('*', () => load()).then((fn) => { unsub = fn; });

    return () => { active = false; if (unsub) unsub(); };
  }, [name, sort]);

  const create = (data) => pb.collection(name).create(clean(data));
  const update = (id, patch) => pb.collection(name).update(id, clean(patch));
  const remove = (id) => pb.collection(name).delete(id);

  return { items, loading, create, update, remove };
}
